import React, { Component } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import {
  IonModal, IonHeader, IonButtons, IonToolbar, IonButton,
  IonContent, IonCard, IonItem, IonTextarea, IonTitle, IonImg,
} from '@ionic/react';

type Props = RouteComponentProps<{}> & {
  showModal: boolean;
  toggleModal: any;
  handleUpload: any;
  caption: string;
  updateCaption: any;
  photo: string;
}

class AddPhotoModal extends Component<Props> {
  render() {
    return (
      <IonModal isOpen={this.props.showModal}>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="end">
              <IonButton onClick={() => this.props.toggleModal()}>Cancel</IonButton>
            </IonButtons>
            <IonTitle slot="start">Share your photo</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonCard>
            <img
              alt=""
              style={{ 'border': '1px solid black', 'minHeight': '100px' }}
              src={this.props.photo} />
          </IonCard>
          <IonItem>
            <IonTextarea
              value={this.props.caption}
              placeholder="Enter Caption"
              onIonChange={e => this.props.updateCaption(e.detail.value!)} />
            {/* <IonInput value={this.state.caption} placeholder="Enter Caption" onIonChange={e => this.updateCaption(e.detail.value!)} clearInput></IonInput> */}
          </IonItem>
          <IonButton expand="block" onClick={() => this.props.handleUpload()}>Share</IonButton>
        </IonContent>
      </IonModal>
    );
  }
};

export default withRouter(AddPhotoModal);
